import Icon from "@/components/ui/icon";
import { cn } from "@lib/cn";

export const MediaLibDialogBase = ({
  children,
}: {
  children: React.ReactNode;
}) => {
  return (
    <div className="tw-rounded-lg tw-bg-white tw-shadow-dialog">{children}</div>
  );
};

const Header = ({
  title,
  onClose,
  className,
}: {
  title: string;
  onClose: () => void;
  className?: string;
}) => {
  return (
    <div
      className={cn(
        "tw-flex tw-h-[72px] tw-items-center tw-justify-between tw-rounded-t-lg tw-border-b tw-border-solid tw-border-blue-100 tw-px-6",
        className,
      )}
    >
      <span className="tw-max-w-[90%] tw-overflow-hidden tw-text-ellipsis tw-text-nowrap tw-font-sans  tw-text-base tw-font-semibold tw-text-blue">
        {title}
      </span>
      <span
        className="tw-flex tw-cursor-pointer tw-items-center tw-justify-center"
        onClick={onClose}
      >
        <Icon
          icon="ri-close-line"
          className="tw-text-2xl tw-text-blue-500 tw-transition-colors tw-duration-200 hover:tw-text-blue-800"
        />
      </span>
    </div>
  );
};

const Content = ({
  children,
  className,
}: {
  children: React.ReactNode;
  className?: string;
}) => {
  return (
    <div className={cn("tw-w-[512px] tw-px-6 tw-pb-14 tw-pt-8", className)}>
      {children}
    </div>
  );
};

const Footer = ({ children }: { children: React.ReactNode }) => {
  return (
    <div className="tw-flex tw-items-center tw-justify-end tw-rounded-b-lg tw-border-t tw-border-solid tw-border-blue-100 tw-bg-blue-50 tw-px-4 tw-py-[14px]">
      {children}
    </div>
  );
};

MediaLibDialogBase.Header = Header;
MediaLibDialogBase.Content = Content;
MediaLibDialogBase.Footer = Footer;
